import {
  AfterContentInit,
  AfterViewInit,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Tarif } from '@wz-models';
import { LoadingService, LoggerService } from '@wz-services';
import * as CryptoJS from 'crypto-js';
import { SouscriptionEnLigneApiService } from 'libs/modules/tunnelsante/services/api/souscription-en-ligne-api.service';
import { DateTime } from 'luxon';
import { TextGarantieModelZenioo } from 'models/text-garantie-model-zenioo.model';
import { TextGarantieMtxVita } from 'models/text-garantie-mtx-vita.model';
import { TexteGarantiesModels } from 'models/texte-garanties.models';
import { Enfant } from '../../insurances/devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../../insurances/devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../../insurances/devis-formulaire/Models/Personne';
import { TaggingService } from '../../insurances/services/tagging.service';
import { DisplayValues } from '../models/tarif-view-model.model';
import { OriginThemeService } from '../originThemeService';
import { Guid_Mdp } from '../souscription-en-ligne/souscription-en-ligne.component';
@Component({
  selector: 'wz-souscription-signature',
  templateUrl: './souscription-signature.component.html',
  styleUrls: ['./souscription-signature.component.scss'],
  standalone: false,
})
export class SouscriptionSignatureComponent
  implements OnInit, AfterViewInit, AfterContentInit
{
  public tarif!: Tarif;
  personne!: Personne;
  enfant: Enfant = new Enfant(0, []);
  niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );

  pathDoc: string = 'assets/doc/';
  filesTypeProduct!: string;
  pathCGProduct!: string;
  pathFidProduct!: string;
  pathTabProduct!: string;
  @Input() GUID: string = '';
  @Input() MDP: string = '';
  doc!: string;
  docLettreBienvenue!: string;
  authentification!: Guid_Mdp;
  @Input() generatePdf: boolean = false;
  valueDisplay!: DisplayValues | any;
  //Tagging
  VisiteurId!: string;
  lead_temp: any;
  loadingLettreBienvenue: boolean = true;
  loadingAdhesionDocumentSignature: boolean = true;
  constructor(
    private souscriptionApi: SouscriptionEnLigneApiService,
    private taggingService: TaggingService,
    private loadingService: LoadingService,
    private originThemeService: OriginThemeService,
    private loggerService: LoggerService,
  ) {}

  ngAfterContentInit(): void {
    //this.loadingService.loadingSubject.next(false);
  }
  ngAfterViewInit(): void {
    const tunnelElement = document.querySelector('body > wz-app-tunnel');
    if (tunnelElement) {
      tunnelElement.scrollTo(0, 0);
    }
    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
    );
    const value = sessionStorage.getItem('app.personne');
    if (value) {
      this.personne = JSON.parse(value);
    }

    const valueTarif = sessionStorage.getItem('app.produittarif');
    if (valueTarif) {
      this.tarif = JSON.parse(valueTarif);
    }

    const getValueDisplay = sessionStorage.getItem('save.valueDisplay');
    if (getValueDisplay) {
      this.valueDisplay = JSON.parse(getValueDisplay);
    }

    const lead = sessionStorage.getItem('app.lead');
    if (lead) {
      this.lead_temp = JSON.parse(lead);
    }
    //Tagging
    this.VisiteurId = this.taggingService.checkVisiteurId();
    if (window['tc_vars'] && window['tC'] && this.VisiteurId != undefined) {
      let sha256Mail = '';

      sha256Mail = CryptoJS.SHA256(
        this.valueDisplay.subscribe.mailSouscripteur,
      ).toString(CryptoJS.enc.Hex);

      this.taggingService.refreshSouscription(
        '4',
        'signature',
        this.VisiteurId,
        sha256Mail,
        this.lead_temp,
        this.tarif,
      );

      window['tC'].event.lead(this, {
        event_id: 'lead',
        event_categorie: 'lead tunnel',
        event_nom: 'completion tunnel',
        event_metier: 'sante',
        event_demande: 'souscription',
        event_statut: 'succes',
        event_user_email_sha256: sha256Mail,
        event_dossier_id: this.lead_temp,
        event_lead_id: this.lead_temp, //??
        event_produit: this.tarif.produitTarif,
        event_partenaire: this.getProduitPartenaires(this.tarif),
        event_beneficiaire: this.checkNbBeneficiaire(this.personne),
        event_user_profil: this.getUserProfile(this.personne), //?? app.personne
        event_user_enfant: this.getEnfantDate(this.personne), //?? app.personne
        event_user_genre: this.getUserGenre(this.personne), //?? app.personne
        event_regime: this.getUserRegime(this.personne), //?? app.personne
        event_user_age: this.calcAge(this.personne.dateNaissanceAssure), //?? app.personne
        event_user_departement: this.personne.codePostal, //?? app.personne
        event_produit_montant_mensuel: this.tarif.montant,
        event_produit_montant_annuel: this.getMontantAnnuel(this.tarif),
        event_type_reglement: this.getTypeReglement(this.valueDisplay), //! 0 == mensuel 1== annuel
        event_loi_madelin: this.valueDisplay.tarifViewModel.LoiMadelin,
      });
    }
  }

  async ngOnInit() {
    this.themeParams();
    let valueAuthent = sessionStorage.getItem('app.guidmdp');
    if (valueAuthent) {
      this.authentification = JSON.parse(valueAuthent);
    }
    this.loadingService.loadingSubject.next(true);
    await this.getAdhesionDocumentsignature();
    await this.getDocumentLettreBienvenue();
  }
  async ngOnChanges() {
    await this.getAdhesionDocumentsignature();
    await this.getDocumentLettreBienvenue();
    // this.generateDoc();
  }

  texteGarantiesSignature(produit: any) {
    switch (produit) {
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamille:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteFamille:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteSenior:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.PrevoirImmediatSanteSenior:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Relaxeo2:
        var p = 'Relaxeo2.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Vitaneor3:
        var p = 'Vitaneor3.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Essentiel2:
        var p = 'Essentiel2.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteFamille:
        var p = 'ESSENTIEL_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteSenior:
        var p = 'ESSENTIEL_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeParticulier:
        var p = 'SWISSLIFE_SANTE_PARTICULIER.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeRetraite:
        var p = 'SWISSLIFE_SANTE_RETRAITE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
        var p = 'ZENIOO_SANTE_INTEGRALE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
        var p = 'ZENIOO_SANTE_INTEGRALE_PLUS.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Optimum:
      case 'MTX_OPTIMUM_SANTE':
        var p = 'Optimum.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteFamille:
        var p = 'PROGR_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteSenior:
        var p = 'PROGR_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaPlus55Nr:
        var p = 'MTX_VITA_SANTE_55PLUS_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaFamilleNr:
        var p = 'MTX_VITA_SANTE_FAMILLE_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'TG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      default:
        break;
    }
  }
  noticeInformationSignature(produit: any) {
    switch (produit) {
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamille:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteFamille:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_FAMILLE.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteSeniorEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteSenior:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.PrevoirImmediatSanteSenior:
        var p = 'PREVOIR_IMMEDIAT_100_SANTE_SENIOR.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Relaxeo2:
        var p = 'Relaxeo2.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Vitaneor3:
        var p = 'Vitaneor3.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Essentiel2:
        var p = 'Essentiel2.pdf';
        this.pathCGProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathCGProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteFamille:
        var p = 'ESSENTIEL_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteSenior:
        var p = 'ESSENTIEL_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeParticulier:
        var p = 'SWISSLIFE_SANTE_PARTICULIER.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeRetraite:
        var p = 'SWISSLIFE_SANTE_RETRAITE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
        var p = 'ZENIOO_SANTE_INTEGRALE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
        var p = 'ZENIOO_SANTE_INTEGRALE_PLUS.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
        var p = 'ZENIOO_SANTE_INTEGRALE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        var p = 'ZENIOO_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
        var p = 'ZENIOO_SANTE_INTEGRALE_PLUS.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteFamille:
        var p = 'PROGR_SANTE_FAMILLE.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteSenior:
        var p = 'PROGR_SANTE_SENIOR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Optimum:
      case 'MTX_OPTIMUM_SANTE':
        var p = 'Optimum.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaFamilleNr:
        var p = 'MTX_VITA_SANTE_FAMILLE_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaPlus55Nr:
        var p = 'MTX_VITA_SANTE_55PLUS_NR.pdf';
        this.pathTabProduct = this.pathDoc + 'CG/' + p;
        window.open(this.pathTabProduct, '_blank');
        break;
      default:
        break;
    }
  }
  async getAdhesionDocumentsignature() {
    this.loadingService.loadingSubject.next(true);
    try {
      var rep = await this.souscriptionApi
        .getAdhesionDocumentSignature()
        .toPromise();
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingService.loadingSubject.next(false);
      this.loadingAdhesionDocumentSignature = false;
    }
    if (rep != '') {
      this.doc = 'data:application/pdf;base64,' + rep;
      this.loggerService.log('');
    }
  }
  async getDocumentLettreBienvenue() {
    this.loadingService.loadingSubject.next(true);
    try {
      var rep = await this.souscriptionApi
        .getDocumentLettreBienvenue()
        .toPromise();
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingService.loadingSubject.next(false);
      this.loadingLettreBienvenue = false;
    }
    if (rep != '') {
      this.docLettreBienvenue = 'data:application/pdf;base64,' + rep;
    }
  }

  downloadSignatureBA() {
    const downloadLink = document.createElement('a');
    const fileName = 'bulletindAdhesion.pdf';
    downloadLink.href = this.doc;
    downloadLink.download = fileName;
    downloadLink.setAttribute('href', this.doc);
    downloadLink.setAttribute('target', '_blank');
    downloadLink.click();
  }

  downloadLettreBienvenue() {
    const downloadLink = document.createElement('a');
    const fileName = 'LettreBienvenue.pdf';
    downloadLink.href = this.docLettreBienvenue;
    downloadLink.download = fileName;
    downloadLink.setAttribute('href', this.docLettreBienvenue);
    downloadLink.setAttribute('target', '_blank');
    downloadLink.click();
  }

  calcAge(dateNaissance: string) {
    let a = new Date().getTime();
    const formats = [
      'dd/MM/yyyy',
      'd/MM/yyyy',
      'dd/M/yyyy',
      'd/M/yyyy',
      'yyyy-MM-dd',
      'yyyy-MM-d',
      'yyyy-M-dd',
      'yyyy-M-d',
    ];

    let b: number = NaN;
    for (const format of formats) {
      const dt = DateTime.fromFormat(dateNaissance, format);
      if (dt.isValid) {
        b = dt.toJSDate().getTime();
        break;
      }
    }

    let timeDiff = Math.abs(a - b);
    let age = Math.round(timeDiff / (1000 * 3600 * 24) / 365.25);
    localStorage.setItem('AgeSouscripteur', age.toString());
    return age;
  }

  checkNbBeneficiaire(personne: Personne) {
    var nbBeneficiaire = 0;
    if (personne.dateNaissanceAssure != null) {
      nbBeneficiaire++;
      if (personne.dateNaissanceConjoint != '') {
        nbBeneficiaire++;
      }
      for (let i = 0; i < personne.enfant.dateNaissanceEnfant.length; i++) {
        if (personne.enfant.dateNaissanceEnfant[i] != null) {
          nbBeneficiaire++;
        }
      }
    }
    return nbBeneficiaire + '';
  }

  getUserProfile(personne: Personne) {
    var profile = '';
    switch (personne.compositionFamiliale) {
      case '1':
        profile = 'un adulte';
        break;
      case '2':
        profile = 'un adulte + enfant(s)';
        break;
      case '3':
        profile = 'un couple';
        break;
      case '4':
        profile = 'un couple + enfant(s)';
        break;
      default:
        break;
    }
    return profile;
  }

  getUserGenre(personne: Personne) {
    var genre = '';
    switch (personne.sexe) {
      case '1':
        genre = 'une femme';
        break;
      case '2':
        genre = 'un homme';
        break;
      default:
        break;
    }
    return genre;
  }

  getUserRegime(personne: Personne) {
    var regime = '';
    switch (personne.regimeSocial) {
      case '0':
        regime = 'regime general';
        break;
      case '1':
        regime = 'travailleur non salarié';
        break;
      case '2':
        regime = 'securite sociale agricole';
        break;
      case '3':
        regime = 'alsace-moselle';
        break;
      default:
        break;
    }
    return regime;
  }
  getMontantAnnuel(tarif: Tarif | any) {
    var montantAnnuel = 0;
    if (tarif.montant !== '') {
      var mtdouble = parseFloat(tarif.montant);
      montantAnnuel = mtdouble * 12;
    }
    return montantAnnuel + '';
  }

  getTypeReglement(value: DisplayValues | any) {
    var typeReglement = '';
    var reglement = value.paiement.fractionnement;
    if (reglement == 0) {
      typeReglement = 'mensuel';
    }
    if (reglement == 1) {
      typeReglement = 'annuel';
    }
    return typeReglement;
  }

  getEnfantDate(personne: Personne) {
    var date = '';
    for (let i = 0; i < personne.enfant.dateNaissanceEnfant.length; i++) {
      if (personne.enfant.dateNaissanceEnfant[i] != '') {
        date += personne.enfant.dateNaissanceEnfant[i];
      }
    }
    return date;
  }

  getProduitPartenaires(tarif: Tarif) {
    var compagnie = '';
    if (
      tarif.produitTarif == 'CEGEMAEss' ||
      tarif.produitTarif == 'CEGEMAV' ||
      tarif.produitTarif == 'CEGE_EQUILIBRE' ||
      tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
      tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
      tarif.produitTarif == 'KEREIS_SERENITE'
    ) {
      compagnie = 'CEGEMA';
    } else if (
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
      tarif.produitTarif == 'RELAXEO2' ||
      tarif.produitTarif == 'ESS_SANTE_FAMILLE' ||
      tarif.produitTarif == 'ESS_SANTE_SENIOR' ||
      tarif.produitTarif == 'PROGR_SANTE_FAMILLE' ||
      tarif.produitTarif == 'PROGR_SANTE_SENIOR' ||
      tarif.produitTarif == 'AC_PRIVILEGE' ||
      tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
      tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
    ) {
      compagnie = 'MEILLEURSTAUX SANTE';
    } else if (
      tarif.produitTarif == 'PARTICULIER' ||
      tarif.produitTarif == 'SWLF_RETRAITES'
    ) {
      compagnie = 'SWISS LIFE';
    } else if (tarif.produitTarif == 'VITAMIN3') {
      compagnie = 'APIVIA';
    }

    return compagnie;
  }

  // Origine theme

  origine!: string;
  originTheme!: any;

  c_theme = 'th_default';
  dowload = 'souscription/dowload.svg';
  bravo = 'souscription/bravo.svg';

  themeParams() {
    const origine: any = localStorage.getItem('codeOrigin');
    this.origine =
      origine && this.originThemeService.IsTrueOrigine(origine)
        ? origine
        : null;
    this.originTheme = this.originThemeService.GetTheme(this.origine, 4);
    if (this.origine) this.useTheme(this.originTheme);
  }

  useTheme(theme: any) {
    this.c_theme = theme.c_theme;
    this.bravo = theme.bravo;
    this.dowload = theme.dowload;
  }
}
